// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1g4O_","choiceBoxes":"toolbarselects_choiceBoxes__mOj6F","simpleField":"toolbarselects_simpleField__1YwHm"};